var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeftSliderButtonIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "32px",
    width: "232x",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 495 495",
    xmlSpace: "preserve",
    fill: "#000000",
    transform: "matrix(-1, 0, 0, 1, 0, 0)",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#00BAFF"
    },
    points: "247.5,197.105 247.5,297.895 297.731,247.5 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00BAFF"
    },
    d: "M247.5,0v140.444L354.208,247.5L247.5,354.556V495C384.19,495,495,384.19,495,247.5 S384.19,0,247.5,0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#00BAFF"
    },
    d: "M223.017,379.119l-28.33-28.238l52.813-52.986V197.105l-52.813-52.986l28.33-28.238l24.483,24.563V0 C110.81,0,0,110.81,0,247.5S110.81,495,247.5,495V354.556L223.017,379.119z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#142862"
    },
    points: "194.687,144.119 247.5,197.105 297.731,247.5 247.5,297.895 194.687,350.881 223.017,379.119 247.5,354.556 354.208,247.5 247.5,140.444 223.017,115.881 "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftSliderButtonIcon);
export default __webpack_public_path__ + "static/media/left_slider_button_icon.0df13754994e2f83fa8ab445851d3c4d.svg";
export { ForwardRef as ReactComponent };